import React from "react";
import {
  ContentSection,
  Heading,
  HeadingText,
  HeadingTextBlue,
  Section,
  TextParagraph,
  TextSection,
  VideoPlay,
  VideoSection,
} from "./StyledWhyHim";
import poster from "./Video Image.png";
import { Skeleton } from "@mui/material";
import { GET_REQUEST } from "~/HooksApi/useApi";
import UseGetData from "~/HookAxios/getdata";
import { Bounce, Fade } from "react-reveal";
import { useRef } from "react";
import Parser from "html-react-parser";

const WhyHim = () => {
  const {
    isLoading: LoadGetWhyus,
    data: dataWhyUs,
    isError: isErrorWhyUs,
    error: errorWhyUs,
    refetch: refetchWhyUs,
  } = GET_REQUEST({
    queryKey: "getWhyHim",
    request: () => UseGetData("get_why_us"),
    enabled: true,
  });
  const Apived = useRef();
  React.useEffect(() => {
    if (dataWhyUs?.data.data.WhyUs[0].video_path) {
      const code = dataWhyUs?.data.data.WhyUs[0].video_path;
      const div = document.createElement("divs");

      div.innerHTML = code.trim();
      let iframe = div.firstChild;
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("height", "100%");
      if (!Apived.current.children[0]) Apived.current.appendChild(iframe);
    }
  }, [LoadGetWhyus]);
  return (
    <Section>
      <ContentSection>
        <TextSection>
          <Heading>لماذا نحن؟</Heading>
          {
            // LoadGetWhyus && !dataWhyUs ? <Skeleton sx={{ height: '13vh' }} />
            //     :
            //     <>
            //         <Bounce right>
            //             <HeadingText>
            //                 {dataWhyUs?.data?.data.WhyUs[0].title}
            //                 {/* <HeadingTextBlue>
            //                 الميزات المفيدة
            //             </HeadingTextBlue> */}
            //             </HeadingText>
            //         </Bounce>
            //     </>
          }
          {LoadGetWhyus && !dataWhyUs ? (
            <>
              {" "}
              <Skeleton sx={{ height: "5vh", minWidth: "250px" }} />{" "}
              <Skeleton sx={{ height: "5vh", margin: "3vh 0" }} />{" "}
              <Skeleton sx={{ height: "5vh" }} />{" "}
            </>
          ) : (
            <>
              {/* <Bounce right> */}
              <TextParagraph style={{ lineHeight: "1.7" }}>
                <Fade cascade>
                  {Parser(dataWhyUs?.data?.data.WhyUs[0].brief)}
                </Fade>
              </TextParagraph>
              {/* </Bounce> */}
            </>
          )}
        </TextSection>
        <Bounce left>
          <VideoSection>
            {LoadGetWhyus && !dataWhyUs ? (
              <>
                {" "}
                <Skeleton
                  sx={{
                    height: "50vh",
                    minWidth: "250px",
                    margin: "10px 30px 10px 10px ",
                  }}
                />{" "}
              </>
            ) : (
              <>
                <Bounce left>
                  <VideoPlay
                    ref={Apived}
                    // poster={poster}
                    // // controls={true}
                    // // playing={true}
                    // src={`${process.env.REACT_APP_BASE_URL}${dataWhyUs?.data?.data.WhyUs[0].video_path}`}
                  />
                </Bounce>
              </>
            )}
          </VideoSection>
        </Bounce>
      </ContentSection>
    </Section>
  );
};

export default WhyHim;
